export function normalizeRibbonBackgroundImage(options = {}) {
    const backgroundImage = options.backgroundImage;
    const backgroundImageMobileId = options.backgroundImageMobileId;
    const backgroundImageTabletId = options.backgroundImageTabletId;
    const backgroundImageDesktopId = options.backgroundImageDesktopId;

    const image = backgroundImage && typeof backgroundImage === 'object' ? backgroundImage : {};

    const desktop = backgroundImageDesktopId || image.desktop || null;
    const mobile = backgroundImageMobileId || image.mobile || null;
    const tablet = backgroundImageTabletId || image.tablet || desktop || mobile || null;

    const normalized = {
        mobile: mobile || tablet || desktop || null,
        tablet: tablet || desktop || mobile || null,
        desktop: desktop || tablet || mobile || null,
    };

    return Object.values(normalized).some(Boolean) ? normalized : null;
}

export function getRibbonTarget(linkUrl) {
    if (!linkUrl) return undefined;

    return linkUrl.includes('#launch') ? '_self' : '_blank';
}

export function getRibbonStartDate(props = {}) {
    return props.countdownTargetDate || props.startDate || null;
}

export function hasRibbonCountdown(props = {}) {
    return Boolean(getRibbonStartDate(props));
}
